import React from "react";
import * as styles from "./ArboretumHero.module.css";
import { ImageItem } from "@kontent-ai/gatsby-components/dist/image-element";
//@ts-ignore
import { useBreakpoint } from "gatsby-plugin-breakpoints";
import { IGatsbyImageData } from "gatsby-plugin-image";
import { KontentImageElement } from "../../elements/KontentImageElement/KontentImageElement";
import { Image } from "../../../types";

interface Props {
  height: "short" | "tall" | "xshort";
  desktopImage: {
    item: ImageItem & { gatsbyImageData?: IGatsbyImageData };
    alt: string;
  };
  mobileImage?: {
    item: ImageItem & { gatsbyImageData?: IGatsbyImageData };
    alt: string;
  };
  contentCategory?: string;
  headline?: string;
  dateTime?: string;
  introText?: string;
  link?: { label: string; href: string; target: string };
  id?: string;
  hideOverlay?: boolean;
  logoImage?: Image;
}

export const ArboretumHero: React.FC<Props> = ({
  height,
  desktopImage,
  mobileImage,
  contentCategory,
  headline,
  dateTime,
  introText,
  logoImage,
  link,
  id,
}) => {
  const breakpoints = useBreakpoint();
  let sectionClassName = styles.arboretumhero;

  switch (height) {
    case "tall":
      sectionClassName += ` ${styles.tall}`;
      break;
    case "xshort":
      sectionClassName += ` ${styles.xshort}`;
      break;
  }

  let heroImage =
    mobileImage?.item?.url && !breakpoints.l ? mobileImage : desktopImage;

  const renderImage = () => {
    return (
      <KontentImageElement
        image={heroImage.item}
        className={styles.kontentImageContainer}
        alt={heroImage.alt}
        width={2500}
        options={{
          quality:
            heroImage.item?.size && heroImage.item?.size > 8000000 ? 15 : 75,
        }}
        layout="fullWidth"
      />
    );
  };

  return (
    <section className={sectionClassName} data-kontent-component-id={id}>
      <div className={styles.imageContainerWrap}>
        {heroImage && renderImage()}
      </div>
      <div className={styles.contentContainerWrap}>
        <div className={styles.contentContainer}>
          <div className={styles.content}>
            {contentCategory && (
              <div
                className={styles.contentCategory}
                data-kontent-element-codename="content_category_tax"
              >
                {contentCategory}
              </div>
            )}
            {logoImage && logoImage?.item?.url && (
              <div>
                <KontentImageElement
                  image={logoImage?.item}
                  alt={logoImage?.alt}
                  height={
                    logoImage?.item?.height < 130
                      ? logoImage?.item?.height
                      : 130
                  }
                  width={
                    logoImage?.item?.height < 130
                      ? logoImage?.item?.width
                      : (130 * logoImage?.item?.width) / logoImage?.item?.height
                  }
                />
              </div>
            )}
          </div>
          <div className={styles.contentBackground}>
            <div className={styles.content}>
              <h1 data-kontent-element-codename="headline">{headline}</h1>
              {introText && (
                <div
                  className={styles.text}
                  data-kontent-element-codename="intro_text"
                >
                  {introText}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
